import React, { useState, useEffect, useRef } from "react";
import style from "./HealthStatus.module.scss";
import { Cross, Pencil, Tick } from "../../../modules/default-svg";
import TextArea from "../../../components/controls/textarea/Textarea";

const HealthStatusTextField = ({ content = '', disabled = false, onChange, placeholder = '', title = '' }) => {
    const [readOnly, setReadonly] = useState(true);
    const [description, setDescription] = useState('');
    const containerRef = useRef(null);
    const maxLength = 350;

    useEffect(() => {
        if (readOnly === false) {
            setTimeout(() => {
                if (containerRef.current) {
                    const textarea = containerRef.current.querySelector('textarea');
                    if (textarea) {
                        textarea.focus();
                    }
                }
            }, 100);
        }
    }, [readOnly]);

    useEffect(() => {
        setDescription(content || '');
    }, [content]);

    const handleDescription = (value) => {
        if (value.length <= maxLength) {
            setDescription(value);
        }
    };

    const handleConfirm = () => {
        onChange(description);
        setReadonly(true);
    };

    const handleCancel = () => {
        setReadonly(true);
        setDescription(content || '');
    };

    return (
        <div className={`${style.itemCard} ${disabled ? style.disabledContainer : ''} mb-3`}>
            <div className={`${style.itemCardHeader} d-flex align-items-center justify-content-between`}>
                <h4 className="text-md-500 BaseMainColor mb-3">{title}</h4>
                {readOnly && !disabled && (
                    <button 
                        type="button" 
                        className={`${style.editbtnstext} ${style.hoverVisible}`} 
                        onClick={() => setReadonly(false)}
                    >
                        <Pencil />
                    </button>
                )}
            </div>
            <div className={style.itemCardBody}>
                <div ref={containerRef}>
                    <TextArea
                        textAreaFieldSize={style.itemCardBodyTextArea}
                        value={description}
                        onChange={(e) => handleDescription(e)}
                        placeholder={placeholder}
                        readonly={readOnly}
                        style={{ FontSize: "14px" }}
                        handleKeyDown={(e) => {
                            if (e.key === 'Enter' && e.ctrlKey) {
                                e.preventDefault();
                                handleConfirm();
                            }
                        }}
                    />
                </div>
                {!readOnly && (
                    <div className="d-flex align-items-center justify-content-between mt-2">
                        <p className="text-xxsm-400 AvatarColor mb-0">
                            {`${description.length}/${maxLength} Characters`}
                        </p>
                        <div className="d-flex gap-2">
                            <button type="button" className="edit-btns" onClick={handleConfirm}>
                                <Tick />
                            </button>
                            <button type="button" className="edit-btns" onClick={handleCancel}>
                                <Cross />
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HealthStatusTextField;
